// extracted by mini-css-extract-plugin
export var holder = "styles-module--holder--ZmVfs";
export var image = "styles-module--image--7HO9I";
export var productAnim = "styles-module--product-anim--7Mnwy";
export var video = "styles-module--video--2ltYk";
export var videos = "styles-module--videos--C3m+Z";